import { render, staticRenderFns } from "./ConfirmationPrompt.vue?vue&type=template&id=32f1868c&scoped=true&"
import script from "./ConfirmationPrompt.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPrompt.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationPrompt.vue?vue&type=style&index=0&id=32f1868c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f1868c",
  null
  
)

export default component.exports